import React, { Component, PropTypes } from 'react'
import $ from 'jquery'

class Photos extends Component {

  componentDidMount() {
      $(document).ready(function(){
          $('.materialboxed').materialbox()
      })
  }

  render() {
    const { photos, title, total } = this.props
    return (
      <div>
        <div className="row content section">
              <span className="content-title">{ title }</span>
      <p>
      { photos.map((photo, index) =>
        <span key={ photo.id } className="col s6 m4 l2 photo-small-padding">
            <img className="responsive-img materialboxed"
                 width="100%"
                 src={photo.url_m}
                 data-caption={`${ title } ${index+1}/${ total }`}
                 alt={`${ title } ${index+1}/${ total }`}
            />
        </span>

      )}
      </p>
      </div>
    </div>
    )
  }
}

const { string, array, number } = PropTypes
Photos.propTypes= {
  id: string,
  photos: array,
  title: string,
  total: number
}

export default Photos



/** WEBPACK FOOTER **
 ** ./src/components/Media/Photos/Photos/Photos.jsx
 **/